export class VisorPdfDocumentoModel {
    seccion: number;
    codigoSolicitud: string;
    idSolicitudDocumento: number;
    idRegistro: number;
    nombreArchivo: string;
    constructor() {
        this.seccion = 0;
        this.codigoSolicitud = '';
        this.idSolicitudDocumento = 0;
        this.idRegistro = 0;
        this.nombreArchivo = '';
    }
}
